import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { DashboardComponent } from '../dashboard/dashboard.component';

import { AuthGuard } from '../_guards/auth.guard';
import { ContractsBalanceComponent } from '../dashboard/contracts-balance/contracts-balance.component';

const routes: Routes = [
    {
        path: 'app',
        component: LayoutComponent,
        children: [
            { path: 'dashboard', component: ContractsBalanceComponent, canActivate: [AuthGuard] },
            { path: 'chart', loadChildren: '../charts/charts.module#ChartsModule' },
            { path: 'dataentry', loadChildren: '../_data-entry/data-entry.module#DataEntryModule' },
            { path: 'commercial', loadChildren: '../_commercial/commercial.module#CommercialModule' },
            { path: 'reports', loadChildren: '../_reports/reports.module#ReportsModule' },
            // EasyMarine AI: a tela React (/ia/) num iframe; Conversas, easymarine-ai/supervisao e easymarine-ai/dashboards
            { path: 'easymarine-ai', loadChildren: '../easymarine-ai/easymarine-ai.module#EasymarineAiModule' },

        ]
    }
];

export const LayoutRoutingModule = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout-routing.module.ts